export default JSON.parse(process.env.VUE_APP_DB)